import React, {Fragment} from 'react';
import styles from './Categories.module.scss';
import CTA from '../common/CTA/CTA';
import PropTypes from 'prop-types';
class Categories extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0
    };

    this.setActiveTab = this.setActiveTab.bind(this)
  }

  setActiveTab(index){
    this.setState({activeTab:index});
  }


  renderVendors(vendors){
    if(vendors){
      return vendors.map((vendor, i) => (
        <div className={styles.vendor} key={`vendor-${i}`}>
          {vendor.src && !vendor.text && <img alt={vendor.altText ? vendor.altText : ""} src={vendor.src} />}
          {vendor.heading && <h4 className={styles.heading}>{vendor.heading}</h4>}
          {vendor.bodyCopy && <p className={styles.bodyCopy}>{vendor.bodyCopy}</p>}
        </div>
      ))
    }
    return null
  }

  renderTabContent
  (sections, data){

    if(sections){
        return (
          <Fragment>
            <div className={styles.vendorsWrapper}>
              {this.renderVendors(sections.vendors)}             
            </div>
            <div className={styles.ctaWrapper}>
                <CTA data={data.cta} />
              </div>
          </Fragment>
        );
    }

    return null
  }

  render(){
    const { data } = this.props;
   
    return (
      <section className={`${styles.categories}`} >
        <div className={`${styles.categoriesWrapper}`} >
          <div className={`${styles.nogutter}`}>
            {data && data.sections &&
              <div className={`${styles.imageWrapper}`}>
              </div>
              }
            <div className={`${styles.contentWrapper}`}>
            {
              data && data.heading && <h2 className={`heading--two ${styles.heading}`}>{data.heading}</h2>
            }
            {
              data && data.subHeading1 && <p className={`subHeading--two ${styles.subHeading}`}>{data.subHeading1}</p>
            }
            {
              data && data.subHeading2 && <p className={`subHeading--two ${styles.subHeading}`}>{data.subHeading2}</p>
            }
            {
              data && data.sectionHeading && <label className={styles.sectionHeading}>{data.sectionHeading}</label>
            }
            {
              data && data.sections && 
                this.renderTabContent(data.sections[0], data)
            }
            </div>
          </div>
        </div>
      </section>
    )
  }

};

Categories.propTypes = {
  data: PropTypes.object
};

Categories.defaultProps = {
  data: {}
}

export default Categories;
